import enhancer from './enhancers'
import ApplicationLayout from './ApplicationsLayout'

export default enhancer(ApplicationLayout)
